import { cva } from 'class-variance-authority';
import { Flex, Text, Tag, Button, List } from '@nula/core-ui';
import styles from './pending-invitations-list.module.css';

const root = cva(styles.root);

export interface PendingInvitation {
  id: string;
  email: string;
  permission: string;
  token: string;
  createdAt: string;
  expiresAt: string;
}

interface PendingInvitationsListProps {
  invitations: PendingInvitation[];
  onRevoke: (id: string) => void;
  revoking?: string | null;
}

export function PendingInvitationsList({ invitations, onRevoke, revoking }: PendingInvitationsListProps) {
  if (invitations.length === 0) return null;

  return (
    <Flex vertical className={root()}>
      <Text size="sm" strong className={styles.sectionTitle}>
        Pending invitations
      </Text>
      <List size="small">
        {invitations.map((inv) => (
          <List.Item key={inv.id}>
            <Flex className={styles.invitationRow} gap="sm">
              <Flex vertical className={styles.info}>
                <Text size="sm" ellipsis>{inv.email}</Text>
                <Text size="xs" type="secondary">{inv.permission} access</Text>
              </Flex>
              <Flex gap="xs" align="center" className={styles.badge}>
                <Tag>{inv.permission}</Tag>
                <Button
                  variant="text"
                  size="sm"
                  danger
                  loading={revoking === inv.id}
                  onClick={() => onRevoke(inv.id)}
                  aria-label={`Revoke invitation for ${inv.email}`}
                >
                  Revoke
                </Button>
              </Flex>
            </Flex>
          </List.Item>
        ))}
      </List>
    </Flex>
  );
}
